import { useCallback, useEffect, useState } from 'react';
import { i18n, t as translate, tEnum as translateEnum, isI18nReady, onI18nReady, type Locale } from '@/infrastructure/i18n';

export function useI18n() {
  const [ready, setReady] = useState(isI18nReady());
  const [locale, setLocaleState] = useState<Locale>(i18n.getLocale());

  useEffect(() => {
    const unsubscribeLocale = i18n.subscribe(() => setLocaleState(i18n.getLocale()));
    const unsubscribeReady = onI18nReady(() => setReady(true));
    return () => {
      unsubscribeLocale();
      unsubscribeReady();
    };
  }, []);

  const setLocale = (l: Locale) => i18n.setLocale(l);
  const t = useCallback(
    (key: string, params?: Record<string, string | number>): string => {
      if (!ready) {
        // 在 ready 之前返回 key
        return key;
      }
      return translate(key, params);
    },
    [ready],
  );
  const tEnum = useCallback(
    (prefix: string, value: string): string => {
      if (!ready) return `${prefix}.${value}`;
      return translateEnum(prefix, value);
    },
    [ready],
  );

  return { t, tEnum, locale, setLocale, ready };
}
